import React from 'react'
import { Button } from '../../../../common';
import { Booklet } from '../../../../types/generated.types';
import ResourceSection from '../../ResourceSection';

interface BookletsViewerProps {
  associationBooklets: Booklet[];
}

const BookletsViewer: React.FC<BookletsViewerProps> = ({ associationBooklets }) => {
  const handleNavigateToBooklet = (bookletId: string) => {
    window.open(`/vara-haften/${bookletId}`, '_blank');
  };
  return (
    <ResourceSection title='Vad finns i häftet?'>
      <p>Se alla erbjudanden som finns i häftet</p>
      <div className="flex flex-col gap-1">
        {associationBooklets.map(booklet => (
          <Button key={booklet._id} onClick={() => handleNavigateToBooklet(booklet._id)} className='primary alt md'>
            <div className="flex gap-1 items-center justify-center">
              <span>{booklet.title}</span>
            </div>
          </Button>
        ))}
      </div>
    </ResourceSection>
  )
}

export default BookletsViewer
